import { render } from "./McustomerView.vue?vue&type=template&id=9edc041e&scoped=true"
import script from "./McustomerView.vue?vue&type=script&lang=js"
export * from "./McustomerView.vue?vue&type=script&lang=js"

import "./McustomerView.vue?vue&type=style&index=0&id=9edc041e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edc041e"]])

export default __exports__